import CountUp from './countUp';

let options, 
    counter,
    counters = [];

function startCounters() {
    
    counters.forEach(function(value, i) {
        counter = new CountUp('counter' + (i + 1), 0, value, 0, 4, options);
        counter.start();        
    });
}

export const countOnScroll = function() {
    
    let counters_div,
        counters_count = 4,
        // add_class_on_scroll,
        counted = false,
        counters_divRect;
    
    // console.log(counters_count);
    for (var i = 1; i <= counters_count; i++) {
        counters.push(document.getElementById('counter' + i).innerHTML);
    }
    
    counters_div = document.getElementById('counters')
    // counters_div_height = counters_div.offsetHeight;
    
    window.addEventListener('scroll', function() { 
        // scrollpos = window.scrollY;
        counters_divRect = counters_div.getBoundingClientRect();
        // console.log(screen.height + ' -> ' + counters_divRect.top);
        
        if (counters_divRect.top < screen.height - 150  && !counted) {
            startCounters();
            counted = true; 
        }
        else {  }
        
    })
    
};

export default countOnScroll;








